import { z } from 'zod';

export const OkResult = z.object({ ok: z.literal(true) });

export interface PaginatedParams {
  cassa?: string;
  page?: number;
  limit?: number;
  sort?: string;
  sortDir?: 'asc' | 'desc';
  q?: string;
  da?: string;
  a?: string;
  statoLavoratore?: string;
  sindacato?: string;
  dataNascitaDa?: string;
  dataNascitaA?: string;
  dataCessazioneDa?: string;
  dataCessazioneA?: string;
  note?: string;
}

export function buildQueryUrl(base: string, opts: PaginatedParams = {}): string {
  const params = new URLSearchParams();
  for (const [chiave, valore] of Object.entries(opts)) {
    if (valore) params.set(chiave, String(valore));
  }
  const qs = params.toString();
  return `${base}${qs ? (base.includes('?') ? '&' : '?') + qs : ''}`;
}

/** Esito di un invio a Statini (deleghe filtrate o coda di presentazione). */
export const StatiniEsitoResult = z.object({
  inviate: z.number(),
  caricate: z.number(),
  giaInviate: z.number(),
  codiceInserimento: z.string().nullable(),
  errori: z.array(z.object({
    delegaId: z.number(),
    lavoratore: z.string(),
    messaggi: z.array(z.string()),
  })),
});

export type StatiniEsito = z.infer<typeof StatiniEsitoResult>;
